module.exports = __webpack_public_path__ + "img/paula_sladda.689ce1ce.png";